import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from '@mui/material'
import { useMemo, useState } from 'react'
import CurrencyField from '../../../components/CurrencyField/CurrencyField'

const ModalDescontoProposta = ({ data, close }) => {
  const saldoProposta = Number(data?.saldoProposta || 0)
  const [vlDesconto, setVlDesconto] = useState(
    Number(data?.vlDescontoCheckin || 0),
  )
  const [prDesconto, setPrDesconto] = useState(
    saldoProposta > 0
      ? ((Number(data?.vlDescontoCheckin || 0) / saldoProposta) * 100).toFixed(
          2,
        )
      : '',
  )

  const valorLimitado = useMemo(
    () => Math.min(Math.max(Number(vlDesconto || 0), 0), saldoProposta),
    [saldoProposta, vlDesconto],
  )

  const confirmar = () => close({ vlDescontoCheckin: valorLimitado })

  return (
    <Dialog open maxWidth="xs" fullWidth onClose={() => close(false)}>
      <DialogTitle>Aplicar Desconto na Proposta</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ pt: 1 }}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Percentual de desconto (%)"
              type="number"
              value={prDesconto}
              inputProps={{ min: 0, max: 100, step: '0.01' }}
              onChange={(event) => {
                const percentual = Math.min(
                  Math.max(Number(event.target.value || 0), 0),
                  100,
                )
                setPrDesconto(event.target.value)
                setVlDesconto((saldoProposta * percentual) / 100)
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <CurrencyField
              label="Valor do desconto"
              value={vlDesconto}
              max={saldoProposta}
              onChange={(valor) => {
                setVlDesconto(valor)
                setPrDesconto(
                  saldoProposta > 0
                    ? ((Number(valor || 0) / saldoProposta) * 100).toFixed(2)
                    : '',
                )
              }}
              helperText={`Saldo disponível: R$ ${saldoProposta.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => close(false)}>Cancelar</Button>
        <Button variant="contained" onClick={confirmar}>
          Aplicar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalDescontoProposta
